import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Product from "../../models/product";
import { withBrand } from "../../utils/brands";

const RECORS_PER_SEARCH = 20;

type ProductSelectProps = {
  value: Product | null;
  disabled?: boolean;
  onChange: (_: Product | null) => void;
};

const ProductSelect: React.FC<ProductSelectProps> = ({ value, disabled, onChange }) => {
  const companyId = useSelector(
    (state: RootState) => state.company.data.company.id
  );
  const loadOptions = async (
    s: string,
    currentOpts: readonly (Product | { options: Product[]; label?: string })[]
  ): Promise<
    Response<Product, { options: Product[]; label?: string }, any>
  > => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();

    additionalParams.set("company_id", companyId!.toString());

    if (s !== "") {
      additionalParams.set("search", s);
    }

    const dataPaginated = await getList<Product>(
      "/clothing_products/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: Product[] = [];
    let count = 0;

    if (dataPaginated.data !== undefined) {
      newOpts = dataPaginated.data.items;
      count = dataPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };
  return (
    <AsyncPaginateBootstrap
      placeholder={"Prenda"}
      onChange={onChange}
      isMulti={false}
      debounceTimeout={300}
      loadOptions={loadOptions}
      getOptionLabel={(option: Product) =>
        withBrand(`${option.codeIdentifier} - ${option.name}`, option.brandName)
      }
      getOptionValue={(option: Product) => `${option.id}`}
      value={value}
      isDisabled={disabled}
    />
  );
};

export default ProductSelect;
